module.exports = __webpack_public_path__ + "static/media/alfa.05fe018d.svg";